import { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { apiIsHallEmpty } from "../api/API";
import { IHall, IObject } from "../App";
import { Alert } from "antd";


type IsHallEmptyForSelectedTimeIntervalCheckerProps = {
    object: IObject;
    hall: IHall;
    date: Dayjs;
    start: Dayjs;
    end: Dayjs;
};

export function IsHallEmptyForSelectedTimeIntervalChecker(props: IsHallEmptyForSelectedTimeIntervalCheckerProps) {

    let [isHallEmpty, setIsHallEmpty] = useState<boolean>(false);

    useEffect( () => {
        apiIsHallEmpty(
            props.object.id,
            props.hall.id,
            props.date,
            props.start,
            props.end,
        ).then( (value) => {
            if(value !== undefined) {
                setIsHallEmpty(value);
            }
        });
    }, [props.start, props.end, props.object.id, props.hall.id, props.date]);

    return (
        <>
            { 
            !isHallEmpty && <Alert message={"Има поне една резервация за избрания интервал"} type="error"/>
            }
        </>
    );
};